import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import AdminNavigationProtectionLayout from 'shared/Layouts/TopNavigationLayout/AdminNavigationProtectionLayout'
import ProtectionDays from './components/protectionDays/ProtectionDays'

const ProtectionRoomsAdminPage = () => {
  return (
    <AdminNavigationProtectionLayout>
      <TopNavigationLayoutPageContent type='default'>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '32px' }}>
            <h2 className='text--heading-h4 page--header' style={{ flexShrink: 0 }}>
              Расписание защит
            </h2>
          </div>
        </div>
        <ProtectionDays />
      </TopNavigationLayoutPageContent>
    </AdminNavigationProtectionLayout>
  )
}

export default ProtectionRoomsAdminPage
